import { extractApiData, isApiSuccess, getApiError } from '../lib/api-helper';
import { ApiResponse } from '../types';
import { apiFetch } from '../lib/apiFetch';

export interface FeedbackRequest {
  type: 'bug' | 'improvement' | 'praise';
  rating: number;
  severity?: 'critical' | 'medium' | 'low';
  message: string;
}

export interface FeedbackResponse {
  success: boolean;
  message: string;
  error?: string;
  adoWorkItem?: {
    created: boolean;
    id: number;
    url: string;
    type: string;
    error?: string;
  } | null;
}

class FeedbackService {
  private readonly API_URL = 
    (window as any).ENV_CONFIG?.API_BASE_URL 
      ? `${(window as any).ENV_CONFIG.API_BASE_URL}/api/feedback`
      : 'http://localhost:5000/api/feedback';

  /**
   * Submit feedback to the server
   */
  async submitFeedback(feedback: FeedbackRequest): Promise<FeedbackResponse> {
    try {
      const response = await apiFetch(`${this.API_URL}/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedback),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiResponse = await response.json() as ApiResponse<FeedbackResponse>;
      if (!isApiSuccess(apiResponse)) {
        return {
          success: false,
          message: getApiError(apiResponse),
          error: getApiError(apiResponse),
        };
      }
      
      const data = extractApiData(apiResponse);
      return data;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      return {
        success: false,
        message: 'Error sending feedback to server',
        error: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  }
}

// Export singleton instance
export const feedbackService = new FeedbackService();
